/ API Reference: https://www.wix.com/corvid/reference
// Code Examples: https://www.wix.com/corvid/examples

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});